webpackJsonp([142695924608309],{

/***/ 639:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Dr Liang Voice Program","short":"DLVP","color":{"primary":"#e64626","secondary":"#424242"}}},"contentfulPost":{"title":"Subscribe","description":{"childMarkdownRemark":{"excerpt":"Subscribe to hear about the latest information, upcoming events and courses offered by the Doctor Liang Voice Program at the University of…"}},"type":"page","tags":null,"publishDate":"2020-04-29T00:00+10:00","heroImage":null,"body":{"childMarkdownRemark":{"html":"<iframe src=\"https://docs.google.com/forms/d/e/1FAIpQLSdNKLii77s99XxUQSysaZvc5Tkf7wubTYWGycF8Ex9AeAUmOA/viewform?embedded=true\" width=\"640\" height=\"729\" frameborder=\"0\" marginheight=\"0\" marginwidth=\"0\">Loading…</iframe>"}}}},"pathContext":{"slug":"subscribe"}}

/***/ })

});


// WEBPACK FOOTER //
// path---subscribe-d2e09647de59fdd398d2.js